import { render } from "./Annuity.vue?vue&type=template&id=712cb2aa&scoped=true"
import script from "./Annuity.vue?vue&type=script&lang=js"
export * from "./Annuity.vue?vue&type=script&lang=js"

import "./Annuity.vue?vue&type=style&index=0&id=712cb2aa&scoped=true&lang=css"

import exportComponent from "/Users/alexisbailly/Documents/Programming/Website/vueform/Wealth & Retirement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712cb2aa"]])

export default __exports__